import { GameStateContext } from './context';

export function GameStateProvider(props) {

    const local_key = "hak12"

    const getState = () => {
        let val = localStorage.getItem(local_key);
        if(val && JSON.parse(val)){
            return JSON.parse(val)
        }
    }

    const updateState = (state) => {
        localStorage.setItem(local_key, JSON.stringify(state));   
    }

    const resetState = (state) =>{
        let val = JSON.parse(localStorage.getItem(local_key));
        console.log(val.securityLoggedIn);
        localStorage.setItem(local_key, JSON.stringify({securityLoggedIn : (val.securityLoggedIn)  ? val.securityLoggedIn : false }));   

    }

    const updateStateCtaOnly = (cta) => {
        let val = localStorage.getItem(local_key);
        if(val){
            let prevState = JSON.parse(val)
            localStorage.setItem(local_key, JSON.stringify({
                ...prevState,
                cta: cta
            }));    
        }
    }

    const updateStateChatOnly = (chat) => {
        let val = localStorage.getItem(local_key);
        if(val){
            let prevState = JSON.parse(val)
            localStorage.setItem(local_key, JSON.stringify({
                ...prevState,
                chat: chat
            }));    
        }
    }

    const setEpisode1Greeting = () => {
        let val = localStorage.getItem(local_key);
        if(val){
            let prevState = JSON.parse(val)
            localStorage.setItem(local_key, JSON.stringify({
                ...prevState,
                ep1_greeting: true
            }));    
        }
    }

    const setEpisode2Greeting = () => {
        let val = localStorage.getItem(local_key);
        if(val){
            let prevState = JSON.parse(val)
            localStorage.setItem(local_key, JSON.stringify({
                ...prevState,
                ep2_greeting: true
            }));    
        }
    }

    const setEpisode3Greeting = () => {
        let val = localStorage.getItem(local_key);
        if(val){
            let prevState = JSON.parse(val)
            localStorage.setItem(local_key, JSON.stringify({
                ...prevState,
                ep3_greeting: true
            }));    
        }
    }

    const setEpisode4Greeting = () => {
        let val = localStorage.getItem(local_key);
        if(val){
            let prevState = JSON.parse(val)
            localStorage.setItem(local_key, JSON.stringify({
                ...prevState,
                ep4_greeting: true
            }));    
        }
    }

    const setEpisode5Greeting = () => {
        let val = localStorage.getItem(local_key);
        if(val){
            let prevState = JSON.parse(val)
            localStorage.setItem(local_key, JSON.stringify({
                ...prevState,
                ep5_greeting: true
            }));    
        }
    }

    const setEpisode6Greeting = () => {
        let val = localStorage.getItem(local_key);
        if(val){
            let prevState = JSON.parse(val)
            localStorage.setItem(local_key, JSON.stringify({
                ...prevState,
                ep6_greeting: true
            }));    
        }
    }
    
    const setEpisodeEnd = () => {
        let val = localStorage.getItem(local_key);
        if(val){
            let prevState = JSON.parse(val)
            localStorage.setItem(local_key, JSON.stringify({
                ...prevState,
                episodeEnd: true
            }));    
        }
    }

    const saveAnimalShelterLoginStatus = (status = false) => {
        let val = localStorage.getItem(local_key);
        if (val) {
            let prevState = JSON.parse(val)
            localStorage.setItem(local_key, JSON.stringify({
                ...prevState,
                animalShelterLoggedIn: status
            }));
        }
    }

    const saveVuMailLoginStatus = (status = false) => {
        let val = localStorage.getItem(local_key);
        if (val) {
            let prevState = JSON.parse(val)
            localStorage.setItem(local_key, JSON.stringify({
                ...prevState,
                securityLoggedIn: status
            }));
        }
    }

    const saveEp6GoodGuyUnlock = (status = false) => {
        let val = localStorage.getItem(local_key);
        if (val) {
            let prevState = JSON.parse(val)
            localStorage.setItem(local_key, JSON.stringify({
                ...prevState,
                ep6GoodGuyUnlock: status
            }));
        }
    }

    

    const saveEp5LockedVideo = (status = false) => {
        let val = localStorage.getItem(local_key);
        if (val) {
            let prevState = JSON.parse(val)
            localStorage.setItem(local_key, JSON.stringify({
                ...prevState,
                ep5LockedVideo: status
            }));
        }
    }

    return (
        <GameStateContext.Provider
            value={{
                getState: () => getState(),
                updateState: (newState) => updateState({...newState}),
                resetState: () => resetState(null),
                setEpisodeEnd: () => setEpisodeEnd(),
                updateStateCtaOnly: (cta) => updateStateCtaOnly(cta),
                updateStateChatOnly: (chat) => updateStateChatOnly(chat),
                saveVuMailLoginStatus: (status) => saveVuMailLoginStatus(status),
                saveAnimalShelterLoginStatus: (status) => saveAnimalShelterLoginStatus(status),          
                saveEp6GoodGuyUnlock: (status) => saveEp6GoodGuyUnlock(status),
                saveEp5LockedVideo,
                setEpisode1Greeting,
                setEpisode2Greeting,
                setEpisode3Greeting,
                setEpisode4Greeting,
                setEpisode5Greeting,
                setEpisode6Greeting
            }}
        >
            {props.children}
        </GameStateContext.Provider>
    );
}